import React from "react";
import { Link } from "react-router-dom";
import { formatPriceINR, formatKm, coverImage } from "../lib/format";
import SafeImage from "./SafeImage";

const StatusBadge = ({ status, isFeatured, isLuxury }) => {
  const map = {
    reserved: { label: "Reserved", cls: "bg-[#242424] text-white" },
    sold: { label: "Sold", cls: "bg-black text-white" },
    coming_soon: { label: "Coming Soon", cls: "bg-white text-[#242424] border hairline" },
  };
  const chip = map[status];
  return (
    <div className="absolute top-3 left-3 flex flex-col gap-1.5 items-start">
      {isLuxury && (
        <span className="text-[10px] tracking-[0.22em] uppercase font-semibold px-2.5 py-1 rounded-sm champagne-chip" data-testid="luxury-badge">Luxury</span>
      )}
      {isFeatured && (
        <span className="text-[10px] tracking-[0.2em] uppercase font-semibold bg-[#7A1519] text-white px-2.5 py-1 rounded-sm">Featured</span>
      )}
      {chip && (
        <span className={`text-[10px] tracking-[0.2em] uppercase font-semibold px-2.5 py-1 rounded-sm ${chip.cls}`}>{chip.label}</span>
      )}
    </div>
  );
};

export const VehicleCard = ({ vehicle, testIdPrefix = "vehicle" }) => {
  const img = coverImage(vehicle);
  const isSold = vehicle.status === "sold";
  const isLuxury = vehicle.segment === "luxury";
  return (
    <Link
      to={`/cars/${vehicle.slug}`}
      className={`group relative block bg-white border hairline rounded-sm overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all duration-500 ${isLuxury ? "luxury-card" : ""}`}
      data-testid={`${testIdPrefix}-card-${vehicle.slug}`}
    >
      <div className="relative aspect-[4/3] bg-[#F7F6F3] image-zoom-container">
        <SafeImage
          src={img}
          alt={`${vehicle.brand} ${vehicle.model}`}
          className="w-full h-full object-cover image-zoom"
        />
        <StatusBadge status={vehicle.status} isFeatured={vehicle.is_featured} isLuxury={isLuxury} />
        {isSold && <div className="absolute inset-0 bg-black/40" />}
      </div>
      <div className="p-5">
        <div className="flex items-baseline justify-between gap-3">
          <div className="text-xs tracking-[0.18em] uppercase text-[#242424]/70 font-semibold min-w-0 truncate">
            {vehicle.manufacturing_year} · {vehicle.body_type}
          </div>
          <div className="font-display font-bold text-[#7A1519] text-xl tracking-tight whitespace-nowrap shrink-0">
            {formatPriceINR(vehicle.price)}
          </div>
        </div>
        <h3 className="mt-1.5 font-display text-xl tracking-tight text-[#111111] font-semibold leading-tight">
          {vehicle.brand} {vehicle.model}
        </h3>
        <div className="text-sm text-[#242424]/75 mt-0.5 min-h-[1.25rem]">{vehicle.variant || " "}</div>

        <div className="mt-4 pt-4 border-t hairline flex items-center justify-between text-sm text-[#242424]/80">
          <span>{formatKm(vehicle.kilometres)}</span>
          <span className="text-[#242424]/40">·</span>
          <span>{vehicle.fuel}</span>
          <span className="text-[#242424]/40">·</span>
          <span>{vehicle.transmission}</span>
        </div>
      </div>
    </Link>
  );
};

export default VehicleCard;
